(function () {
  var audio = document.getElementById("cozy-sound");
  var btn = document.querySelector(".cozy-sound__btn");
  if (!audio || !btn) return;

  var key = "cozy-sound";
  var timeKey = "cozy-sound-time";
  var saved = localStorage.getItem(key);
  var label = btn.querySelector(".cozy-sound__label");
  var looping = false;
  audio.volume = 0.22;

  function setOn(on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.setAttribute("aria-label", on ? "Pause soft music" : "Play soft music");
    if (label) label.textContent = on ? "Music on" : "Music";
  }

  function remember() {
    if (audio.currentTime > 0) sessionStorage.setItem(timeKey, String(audio.currentTime));
  }

  function restoreTime() {
    var t = parseFloat(sessionStorage.getItem(timeKey) || "0");
    if (!audio.duration || !isFinite(t)) return;
    if (t > 0.4 && t < audio.duration - 1.2) audio.currentTime = t;
  }

  function keepLooping() {
    if (!audio.duration || audio.paused || looping) return;
    if (audio.currentTime < audio.duration - 0.35) return;
    looping = true;
    audio.currentTime = 0.35;
    var pending = audio.play();
    if (pending) pending.catch(function () {});
    window.setTimeout(function () {
      looping = false;
    }, 400);
  }

  audio.addEventListener("loadedmetadata", restoreTime);
  audio.addEventListener("timeupdate", function () {
    remember();
    keepLooping();
  });
  audio.addEventListener("ended", function () {
    audio.currentTime = 0.35;
    var pending = audio.play();
    if (pending) pending.catch(function () {});
  });
  window.addEventListener("pagehide", remember);

  function play() {
    restoreTime();
    var pending = audio.play();
    if (!pending) return Promise.resolve();
    return pending.then(function () {
      setOn(true);
      localStorage.setItem(key, "on");
    }).catch(function () {
      setOn(false);
    });
  }

  function stop() {
    audio.pause();
    setOn(false);
    localStorage.setItem(key, "off");
  }

  btn.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (audio.paused) play();
    else stop();
  });

  if (saved === "off") {
    setOn(false);
  } else {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!(reduce && saved !== "on")) {
      play();
      document.addEventListener("pointerdown", function arm(event) {
        if (event.target.closest && event.target.closest(".cozy-sound")) return;
        document.removeEventListener("pointerdown", arm);
        if (audio.paused && localStorage.getItem(key) !== "off") play();
      });
    } else {
      setOn(false);
    }
  }

  function samePage(url) {
    return url.pathname === location.pathname && url.search === location.search;
  }

  function canSoftNavigate(link, event) {
    if (!link || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== "_self") return false;
    if (link.hasAttribute("download")) return false;
    var url;
    try {
      url = new URL(link.href, location.href);
    } catch (error) {
      return false;
    }
    if (url.origin !== location.origin) return false;
    if (url.protocol === "javascript:" || url.hash && samePage(url)) return false;
    if (/^\/(checkout|account|apps|challenge)(\/|$)/.test(url.pathname)) return false;
    return url;
  }

  function swapPage(html, url) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector("#MainContent");
    var current = document.querySelector("#MainContent");
    if (!next || !current) return false;
    current.replaceWith(next);
    if (doc.title) document.title = doc.title;
    history.pushState({ cozy: true }, "", url.pathname + url.search + url.hash);
    window.scrollTo(0, 0);
    document.dispatchEvent(new CustomEvent("cozy:page"));
    return true;
  }

  function softGo(url) {
    return fetch(url.href, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("status");
        return response.text();
      })
      .then(function (html) {
        if (!swapPage(html, url)) location.href = url.href;
      })
      .catch(function () {
        location.href = url.href;
      });
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a[href]");
    var url = canSoftNavigate(link, event);
    if (!url || samePage(url)) return;
    event.preventDefault();
    softGo(url);
  });

  window.addEventListener("popstate", function () {
    fetch(location.href, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = doc.querySelector("#MainContent");
        var current = document.querySelector("#MainContent");
        if (!next || !current) return;
        current.replaceWith(next);
        if (doc.title) document.title = doc.title;
        window.scrollTo(0, 0);
        document.dispatchEvent(new CustomEvent("cozy:page"));
      })
      .catch(function () {});
  });
})();
